import { useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../api";
import { useAuth } from "../AuthContext";

export const ProfileEditor = () => {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch("/users/me", { name, phone });
      setUser(r.data);
      toast.success("Profile updated");
    } catch (e) { toast.error(fmtErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-2" data-testid="profile-editor">
      <input data-testid="profile-name" className="field-input w-full" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} />
      <input data-testid="profile-phone" type="tel" className="field-input w-full" placeholder="Your phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
      <button data-testid="profile-save" onClick={save} disabled={busy || !name.trim()}
        className="h-12 w-full rounded-md bg-primary text-sm font-bold text-primary-foreground disabled:opacity-40">Save profile</button>
    </div>
  );
};
